exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3dl53FObUKqbcyPODM5mYf{padding:50px 40px 60px 40px;text-align:center}._2JNapoygL9RTsMyNwtxeC5{margin-bottom:30px}._19mx3QkvfAGcfchPlE879H{margin-bottom:30px}._2qILHc6_xG6vFLoZ14VqKd{margin-top:40px;margin-bottom:30px}\n", ""]);

// Exports
exports.locals = {
	"card": "_3dl53FObUKqbcyPODM5mYf",
	"graphic": "_2JNapoygL9RTsMyNwtxeC5",
	"leadText": "_19mx3QkvfAGcfchPlE879H",
	"trialText": "_2qILHc6_xG6vFLoZ14VqKd"
};